import {rtkQueryApi} from '~/shared/api/rtk-query-api';
import {buildFiltersParams} from '~/shared/utils/buildFiltersParams';
import {IUserPagination} from '../types/types';

export const usersApi = rtkQueryApi
  .enhanceEndpoints({
    addTagTypes: ['users', 'buyers'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getUsers: builder.query<IUserPagination, any>({
        query: ({page, pageSize, search, sort_by, sort_dir}: any) => {
          const params = new URLSearchParams();
          params.set('page', page);
          params.set('page_size', pageSize);
          if (search?.trim()) params.set('search', search.trim());
          if (sort_by) params.set('sort_by', sort_by);
          if (sort_dir) params.set('sort_dir', sort_dir);

          return {
            url: `users?${params.toString()}`,
            method: 'GET',
          };
        },
        providesTags: ['users'],
        transformResponse: res => {
          return res;
        },
      }),
      getFilteredUsers: builder.query<IUserPagination, any>({
        query: ({page, pageSize, search, filters, sort_by, sort_dir}: any) => {
          const params = new URLSearchParams();
          params.set('page', page);
          params.set('page_size', pageSize);
          if (search?.trim()) {
            params.set('search', search.trim());
          }
          if (sort_by) params.set('sort_by', sort_by);
          if (sort_dir) params.set('sort_dir', sort_dir);

          const filtersParams = buildFiltersParams(filters);
          filtersParams.forEach((value, key) => {
            params.append(key, value);
          });

          return {
            url: `/users?${params.toString()}`,
            method: 'GET',
          };
        },
        providesTags: ['users'],
        transformResponse: res => {
          return res;
        },
      }),
      getBuyers: builder.query({
        query: () => ({
          url: `users/buyers`,
          method: 'GET',
        }),
        providesTags: ['buyers'],
        transformResponse: res => {
          return res;
        },
      }),
      updateRole: builder.mutation({
        query: ({user_id, role}) => ({
          url: '/users/assign',
          method: 'POST',
          body: {user_id, role},
        }),
        invalidatesTags: ['users'],
      }),
      getUserInfo: builder.query({
        query: () => ({
          url: 'users/info',
          method: 'GET',
        }),
        keepUnusedDataFor: 300,
        providesTags: ['users'],
        transformResponse: res => {
          return res;
        },
      }),
    }),
  });

export const {
  useGetUsersQuery,
  useLazyGetFilteredUsersQuery,
  useGetBuyersQuery,
  useUpdateRoleMutation,
  useGetUserInfoQuery,
} = usersApi;
